<template>
  <div>
    <Header />
    <v-img
      :src="require('@/assets/bannerProvUbicacion.jpg')"
      :lazy-src="require('@/assets/carruselLazyLoad.jpg')"
      aspect-ratio="3.65"
      contain
    >
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row>
      </template>
    </v-img>

    <v-row align="center" justify="center" no-gutters>
      <v-breadcrumbs :items="itemsBreadCrumbs" large>
        <template v-slot:divider>
          <v-icon>mdi-forward</v-icon>
        </template>
      </v-breadcrumbs>
    </v-row>

    <v-col cols="12" class="pt-5">
      <v-row align="center" justify="center">
        <v-card
          class="ma-3 pa-6"
          style="border: 0px solid white"
          width="700"
          outlined
          tile
        >
          <p
            class="subfont text-justify text-center mb-0"
            :class="[
              $vuetify.breakpoint.mdAndUp ? 'subfont' : 'subfontResponsive',
            ]"
          >
            Amplia red de proveedores estrátegicamente ubicados en las
            principales ciudades y carreteras de tráfico internacional que se
            traduce en tiempos de respuesta cortas.
          </p>
        </v-card>
      </v-row>
    </v-col>

    <v-container>
      <v-row class="d-flex justify-space-around">
        <v-col cols="12" md="4">
          <div
            id="mapContainer"
            class="mx-auto"
            style="max-width:750px; height: 550px"
          ></div>
        </v-col>

        <v-col cols="12" md="4" class="my-auto">
          <v-card max-width="375" class="mx-auto">
            <v-card-title
              class="text-xl-h4 pt-1"
              :class="[
                $vuetify.breakpoint.mdAndUp
                  ? 'fontTitulo'
                  : 'fontTituloResponsive',
              ]"
              >CON PRESENCIA EN:</v-card-title
            >
            <v-list dense>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>FRONTERA EL POY</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(1)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>OCOTEPEQUE</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(2)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>CUCUYAGUA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(3)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>SANTA ROSA DE COPÁN</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(4)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>LA ENTRADA A COPAN</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(5)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>SANTA BARBARA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(6)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>SAN PEDRO SULA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(7)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>EL PROGRESO</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(8)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>LA LIMA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(9)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>TELA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(10)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>LA CEIBA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn
                    small
                    color="blue"
                    outlined
                    @click="Flyto(11)"
                    v-scroll-to="'#mapContainer'"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <v-col cols="12" md="4" class="my-auto">
          <v-card max-width="375" class="mx-auto">
            <v-card-title
              class="text-xl-h4 pt-1"
              :class="[
                $vuetify.breakpoint.mdAndUp
                  ? 'fontTitulo'
                  : 'fontTituloResponsive',
              ]"
              >CON PRESENCIA EN:</v-card-title
            >
            <v-list dense>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>ATLANTIDA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(12)"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>SIGUATEPEQUE</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(13)"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>COMAYAGUA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(14)"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>TEGUCIGALPA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(15)"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>JICARO GALAN</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(16)"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>CHOLUTECA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(17)"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>NACAOME</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(18)"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>FRONTERA EL AMATILLO</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(19)"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>FRONTERA EL GUASAULE</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(20)"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>JUTICALPA</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn small color="blue" outlined @click="Flyto(21)"
                    >Ver</v-btn
                  >
                </v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <ButtonScroll />
    <Footer />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import ButtonScroll from "../components/ButtonScroll.vue";
import mapboxgl from "mapbox-gl";

export default {
  components: {
    Header,
    Footer,
    ButtonScroll,
  },
  data: () => ({
    markers: [
      {
        id: 1,
        name: "FRONTERA EL POY",
        position: {
          lat: 14.370574,
          lng: -89.209693,
        },
      },
      {
        id: 2,
        name: "OCOTEPEQUE",
        position: {
          lat: 14.435643,
          lng: -89.182849,
        },
      },
      {
        id: 3,
        name: "CUCUYAGUA",
        position: {
          lat: 14.65129,
          lng: -88.875918,
        },
      },
      {
        id: 4,
        name: "SANTA ROSA DE COPÁN",
        position: {
          lat: 14.766991,
          lng: -88.777601,
        },
      },
      {
        id: 5,
        name: "LA ENTRADA A COPAN",
        position: {
          lat: 15.060926,
          lng: -88.755756,
        },
      },
      {
        id: 6,
        name: "SANTA BARBARA",
        position: {
          lat: 14.992609,
          lng: -88.277964,
        },
      },
      {
        id: 7,
        name: "SAN PEDRO SULA	",
        position: {
          lat: 15.50252,
          lng: -88.024633,
        },
      },
      {
        id: 8,
        name: "EL PROGRESO",
        position: {
          lat: 15.401397,
          lng: -87.808158,
        },
      },
      {
        id: 9,
        name: "LA LIMA",
        position: {
          lat: 15.436465,
          lng: -87.914272,
        },
      },
      {
        id: 10,
        name: "TELA",
        position: {
          lat: 15.782818,
          lng: -87.452333,
        },
      },
      {
        id: 11,
        name: "LA CEIBA",
        position: {
          lat: 15.77977,
          lng: -86.789228,
        },
      },
      {
        id: 12,
        name: "ATLANTIDA",
        position: {
          lat: 15.621806,
          lng: -87.231785,
        },
      },
      {
        id: 13,
        name: "SIGUATEPEQUE",
        position: {
          lat: 14.596123,
          lng: -87.830586,
        },
      },
      {
        id: 14,
        name: "COMAYAGUA",
        position: {
          lat: 14.458936,
          lng: -87.641002,
        },
      },
      {
        id: 15,
        name: "TEGUCIGALPA",
        position: {
          lat: 14.076572,
          lng: -87.200855,
        },
      },
      {
        id: 16,
        name: "JICARO GALAN",
        position: {
          lat: 13.531388,
          lng: -87.438029,
        },
      },
      {
        id: 17,
        name: "CHOLUTECA",
        position: {
          lat: 13.3109,
          lng: -87.178831,
        },
      },
      {
        id: 18,
        name: "NACAOME",
        position: {
          lat: 13.536111,
          lng: -87.4937,
        },
      },
      {
        id: 19,
        name: "FRONTERA EL AMATILLO",
        position: {
          lat: 13.594786,
          lng: -87.765016,
        },
      },
      {
        id: 20,
        name: "FRONTERA EL GUASAULE",
        position: {
          lat: 13.062245,
          lng: -86.956776,
        },
      },
      {
        id: 21,
        name: "JUTICALPA",
        position: {
          lat: 14.66866,
          lng: -86.218171,
        },
      },
    ],
    itemsBreadCrumbs: [
      {
        text: "HOME",
        disabled: false,
        href: "/",
      },
      {
        text: "NUESTROS PROVEEDORES HONDURAS",
        disabled: true,
        href: "",
      },
    ],
    map: "",
    accessToken:
      "pk.eyJ1Ijoiam9obmxpbmFyZXMiLCJhIjoiY2tjcWk2eDZrMTU2bjJyczVyMWF0ejg3NiJ9.848u9JaZDYfKTRPBzFvDwA",
  }),

  mounted() {
    mapboxgl.accessToken = this.accessToken;
    this.map = new mapboxgl.Map({
      container: "mapContainer",
      style: "mapbox://styles/mapbox/streets-v11",
      center: [-87.084511, 14.844983],
      zoom: 6,
    });
    for (var i = 0; i < this.markers.length; i++) {
      var marker = new mapboxgl.Marker({ color: "blue" })
        .setLngLat(this.markers[i].position)
        .setPopup(
          new mapboxgl.Popup({ offset: 25 }).setHTML(
            "<strong>" + this.markers[i].name + "</strong>"
          )
        )
        .addTo(this.map);
    }
    this.map.addControl(new mapboxgl.FullscreenControl());
    this.map.addControl(
      new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true,
        },
        trackUserLocation: true,
      })
    );
    this.map.addControl(new mapboxgl.NavigationControl());
  },

  methods: {
    Flyto(i) {
      switch (i) {
        case 1:
          var center = this.markers[i - 1].position;
          break;
        case 2:
          var center = this.markers[i - 1].position;
          break;
        case 3:
          var center = this.markers[i - 1].position;
          break;
        case 4:
          var center = this.markers[i - 1].position;
          break;
        case 5:
          var center = this.markers[i - 1].position;
          break;
        case 6:
          var center = this.markers[i - 1].position;
          break;
        case 7:
          var center = this.markers[i - 1].position;
          break;
        case 8:
          var center = this.markers[i - 1].position;
          break;
        case 9:
          var center = this.markers[i - 1].position;
          break;
        case 10:
          var center = this.markers[i - 1].position;
          break;
        case 11:
          var center = this.markers[i - 1].position;
          break;
        case 12:
          var center = this.markers[i - 1].position;
          break;
        case 13:
          var center = this.markers[i - 1].position;
          break;
        case 14:
          var center = this.markers[i - 1].position;
          break;
        case 15:
          var center = this.markers[i - 1].position;
          break;
        case 16:
          var center = this.markers[i - 1].position;
          break;
        case 17:
          var center = this.markers[i - 1].position;
          break;
        case 18:
          var center = this.markers[i - 1].position;
          break;
        case 19:
          var center = this.markers[i - 1].position;
          break;
        case 20:
          var center = this.markers[i - 1].position;
          break;
        case 21:
          var center = this.markers[i - 1].position;
          break;
      }
      this.map.flyTo({
        center: center,
        zoom: 13,
        bearing: 0,
        speed: 0.5,
        curve: 1,
        easing: function(t) {
          return t;
        },
        essential: true,
      });
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Zilla+Slab:ital,wght@1,700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=EB+Garamond:wght@500&family=Zilla+Slab:ital,wght@1,700&display=swap");

.subfont {
  font-family: "EB Garamond", serif;
  font-size: 25px;
}
.subfontResponsive {
  font-family: "EB Garamond", serif;
  font-size: 15px;
}
</style>
